<template>
  <va-create-layout>
    <publishers-form :title="title" :item="item"></publishers-form>
  </va-create-layout>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    item: {
      type: Object,
      default: null,
    },
  },
};
</script>
